import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { useCacheOperations } from "@/composables/cache";

const { info: logInfo } = useLogger(
  "LOWER_Y_TOOL_EQUIPMENT_TUBINGS_XREF_RESOLVER"
);

export default {
  queries: {
    sc_equip_xref_downhole_ytool_equip_tubings: {
      tubing: (parent, args, cache, info) => {
        return parent.tubing_id
          ? { __typename: "tubings", id: parent.tubing_id }
          : null;
      }
    }
  },
  optimistic: {
    insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions(
      vars,
      cache,
      info
    ) {
      logInfo("Optimistic", { vars, cache, info });
      return {
        __typename:
          "revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_mutation_response",
        returning: vars.objects.map(object => ({
          id: object.id,
          __typename:
            "revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions",
          sc_equip_xref_downhole_ytool_equip_tubings_view: {
            __typename:
              "sc_equip_xref_downhole_ytool_equip_tubings",
            ...object,
            ...revisionDefaultFields(object),
            tubing: null
          }
        }))
      };
    }
  },
  updates: {
    insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions(
      result,
      args,
      cache,
      info
    ) {
      logInfo("Mutation", { result, args, cache, info });
      args.objects.forEach(object => {
        const { handleCacheUpdate } = useCacheOperations({
          cache,
          object,
          typename: "sc_equip_xref_downhole_ytool_equip_tubings"
        });

        handleCacheUpdate([
          {
            args: {
              where: {
                journal_deleted_at: {
                  _is_null: true
                }
              }
            },
            relatedCacheKey: cache.keyOfEntity({
              __typename: "scenario_equipment",
              id: object.scenario_equipment_id
            }),
            relatedField: "downhole_xref_y_tool_equipment_tubings"
          }
        ]);
      });
    }
  }
} as ModelsResolver;
